import rails from '../../assets/img/logos/rails.png';
import html from '../../assets/img/logos/b&w/html.png';
import react from '../../assets/img/logos/b&w/react.png';
import js from '../../assets/img/logos/b&w/js.png';
import stock_tweeter from '../../assets/img/gallery/stock-tweeter.png';
import shop from '../../assets/img/gallery/shop.png';
import blog from '../../assets/img/gallery/blog.png';
import tvmaze from '../../assets/img/gallery/tvmaze.png';
import nextweb from '../../assets/img/gallery/nextweb.png';
import homeKitchen from '../../assets/img/gallery/home-kitchen.png';

export default [
	{
		media: { icon: rails },
		tech: [
			'Ruby',
			'Rails',
			'Bootstrap',
			'Scss',
			'HTML',
			'AWS',
			'Rspec',
			'Capibara',
		],
		path: 'http://stock-tweeter.herokuapp.com/users/sign_in',
		git: 'https://github.com/Bekhzod96/stock-tweet',
		image: stock_tweeter,
		title: 'Stock - Tweeter',
		description:
			'Social Application for real time messaging to other members of the app. Main purpose of the application to get real time stock price and Discuss with other member of the application ',
	},
	{
		media: { icon: html },
		tech: ['HTML5', 'CSS', 'Bootstrap', 'Linter'],
		path:
			'https://rawcdn.githack.com/Bekhzod96/Uzbek_Souvenir-Shop/d8894e72d967aee82b0974bead43990df5200391/index.html',
		git: 'https://github.com/Bekhzod96/Uzbek_Souvenir-Shop',
		image: shop,
		title: 'Souvenir Shop',
		description:
			'I created an online shop for souvenirs and traditional Uzbek clothes and shoes. The main page includes in itself the ADS section and top product according to the category. ',
	},
	{
		media: { icon: rails },
		tech: [
			'Ruby',
			'Rails',
			'Bootstrap',
			'Scss',
			'HTML',
			'AWS',
			'Rspec',
			'Capibara',
		],
		path: 'http://beka-blog.herokuapp.com/',
		git: 'https://github.com/Bekhzod96/beka_blog',
		image: blog,
		title: 'Social Blog ',
		description:
			'Post most recent thought about tech article possible in this application. Review categorized post and get list of the members of the Application has been implemented ',
	},
	{
		media: { icon: js },
		tech: ['React', 'Bootstrap', 'Webpack', 'JavaScrip'],
		path: '#',
		git: 'https://github.com/Bekhzod96/TvMazeApp',
		image: tvmaze,
		title: 'Social Blog ',
		description:
			'Post most recent thought about tech article possible in this application. Review categorized post and get list of the members of the Application has been implemented ',
	},
	{
		media: { icon: html },
		tech: ['HTML5', 'CSS', 'Linter'],
		path:
			'https://rawcdn.githack.com/Bekhzod96/theNextWeb/d3c0d784790e40d16899e252869040bb3d8ff14a/index.html',
		git: 'https://github.com/Bekhzod96/theNextWeb',
		image: nextweb,
		title: 'The NextWeb App',
		description:
			'I have cloned The Next Web, a tech-focused magazine which uses media queries to gracefully degrade their site as the window size is reduced. The process is quite similar to what we’ve done before.',
	},
	{
		media: { icon: react },
		tech: ['React', 'JS', 'Bootstrap', 'Scss'],
		path: 'https://home-kitchen-beka.web.app/',
		git: 'https://github.com/Bekhzod96/home-kitchen',
		image: homeKitchen,
		title: 'Home Kitchen',
		description:
			'This Application build by using ReactJS Library. Layout was taken from MTC Home Kitchen. It contains only one page as it was layout creation process without functionality of this React.',
	},
];
